/**
 * Created by mac on 7/26/18
 */

const WoodenSoftFeastWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, options) {
        this.mission = mission;

        options = options || {};
        this.options = options;

        this.name = options.name || `${mission.getName()}_WoodenSoftFeastWindow`;
        this.bundleName = options.bundleName || `${mission.getName().toLowerCase()}_window`;

        const offer = this.offer = cleverapps.offerManager.findOffer({ mission: mission.type });

        this._super({
            name: "SoftFeastMissionWindow",
            content: new WoodenSoftFeastView(this),
            noBackground: true,
            closeButton: false,
            styles: cleverapps.styles.WoodenSoftFeastWindow.window,
            notCloseByTouchInShadow: true,
            openSound: bundles.softfeast_window.urls.feast_window_effect,
            offerWindowButton: offer ? {
                text: Messages.get(`FeastMissionWindow.${mission.getName()}.offer`),
                offerType: offer.type,
                onClicked: this.onOfferClicked.bind(this),
                bundle: this.bundleName,
                badgeText: Messages.get(`FeastMissionWindow.${mission.getName()}.offerBadge`)
            } : undefined,
            pack: {
                type: "soft",
                price: 250,
                prizes: RewardsConfig.SoftFeast.offer
            }
        });

        this.mission.updateCompetitionResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    onOfferClicked: function () {
        ComponentMap.get(this, WindowComponent).closeWindow();
        cleverapps.offerManager.showOfferWindow(this.offer);
    },

    onShow: function () {
        this._super();

        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();

        this._super();
    },

    getPerson: function () {
        return {
            role: "elf",
            emotion: "happy"
        };
    },

    listBundles: function () {
        return ["softfeast_window"];
    }
});

cleverapps.styles.WoodenSoftFeastWindow = {
    verticalWindow: {
        windowShowUpAnimation: undefined,
        Background: {
            padding: {
                x: -10
            }
        }
    },

    window: {
        windowShowUpAnimation: undefined
    },

    pack: {
        x: { align: "center", dx: -78 },
        y: { align: "center", dy: -487 }
    }
};

cleverapps.styles.WoodenSoftFeastWindow = {
    pack: {
        x: { align: "center", dx: -78 },
        y: { align: "center", dy: -487 }
    }
};
